<template>
  <k-layout row wrap v-show="show">
    <slot></slot>
  </k-layout>
</template>
<script>
import {EventMixin} from '@/lib/mixins.js';
export default {
  mixins: [EventMixin],
  props: [
    'value'
  ]
}
</script>
